import { CalendarOutlined, CaretDownOutlined, CaretUpOutlined } from "@ant-design/icons"
import { Button, Select, Space, Typography } from "antd"
// import { t } from "i18next"
import React from "react"
import { t } from "~/languages/i18n"
import { LanguagePublish, StatusPublish, VisibilityPublish } from "~/modules/post/pages/StatusPublish"
import { PublishProps } from "~/types/types"
const { Title, Text } = Typography

const Publish: React.FC<PublishProps> = ({
  onSubmit,
  isCreateEdit,
  setStatus,
  status,
  setPublishDate,
  onPageTypeChanged,
  language,
  setLanguages,
}) => {
  const [isPublishListVisible, setPublishListVisible] = React.useState(true)

  return (
    <div className="publish border-gray-300 border rounded-[10px] mb-5">
      <div className="flex justify-between items-center px-4 py-3 border-b">
        <Title level={4} className="!m-0">
          {t("Publish")}
        </Title>
        <Button
          onClick={() => setPublishListVisible(!isPublishListVisible)}
          className="flex items-center"
          icon={isPublishListVisible ? <CaretDownOutlined /> : <CaretUpOutlined />}
          type="text"
        />
      </div>

      {isPublishListVisible && (
        <div>
          <Space direction="vertical" className="px-4 py-4">
            {onPageTypeChanged && (
              <Text className="flex items-center text-sm">
                <CalendarOutlined className="mr-2" /> {t("Content type")}:
                <Select
                  defaultValue={t("Nội dung")}
                  onChange={value => onPageTypeChanged(value === "UI Builder")}
                  className="ml-2 w-fit"
                >
                  <Select.Option value="Nội dung">{t("Content")}</Select.Option>
                  <Select.Option value="UI Builder">{t("UI Builder")}</Select.Option>
                </Select>
              </Text>
            )}
            <StatusPublish setStatus={setStatus} status={status} />
            <LanguagePublish language={language} setLanguages={setLanguages} isCreateEdit={isCreateEdit} />
            <VisibilityPublish />
          </Space>
          <div className="flex justify-end border-t pt-3 px-4 bg-[#f6f7f7] rounded-b-[10px] h-14">
            <Button type="primary" onClick={onSubmit}>
              {isCreateEdit ? t("Publish") : t("Update")}
            </Button>
          </div>
        </div>
      )}
    </div>
  )
}

export default Publish
